import { useSelector } from 'react-redux'
import { eventsIdSelectors } from '@ucheba/store/events/id'
import React, { FC, useMemo } from 'react'
import { getSingleQuery } from '@ucheba/utils/helpers/router'
import { useRouter } from 'next/router'
import { useFinishedEvent } from '../../bll'
import { IEventPage } from '../../types'
import EventPageBrandingFinished from './EventPageBrandingFinished'
import EventPageBrandingUchebaNotFinished from './EventPageBrandingUchebaNotFinished'
import { templatesID } from '../../../../pages/for-abiturients/events/[id]/constants'

const EventPageBranding: FC<IEventPage> = (props) => {
  const { bannerProgramTypes, onClickAction, pathname } = props
  const event = useSelector(eventsIdSelectors.entity)

  const isFinished = useFinishedEvent(event?.startAt, event?.endAt)
  const { query } = useRouter()
  const eventId = useMemo(() => Number(getSingleQuery(query.id)), [query])

  const templateId = useMemo(() => {
    if (eventId in templatesID && !isFinished) {
      return Number(templatesID[eventId])
    }
    return 26
  }, [eventId, isFinished])

  if (!event) return null

  if (isFinished) {
    return (
      <EventPageBrandingFinished
        {...event}
        bannerProgramTypes={bannerProgramTypes}
        onClickAction={onClickAction}
        pathname={pathname}
        templateId={templateId}
      />
    )
  }

  /* Нужно будет поправить наименования для компонент, раньше было только для учёбы, теперь общее,
       пока непонятно нужна ли логика из EventPageBrandingNotFinished  */
  return <EventPageBrandingUchebaNotFinished {...event} templateId={templateId} />
}

export default EventPageBranding
